import React, { useState, useEffect } from 'react';
import '../../css/TransferTable.css'

const TransferKey = () => {
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // Phone detection: either portrait (width <= 480) or landscape (height <= 480 && width <= 896)
      const isPhonePortrait = width <= 480;
      const isPhoneLandscape = height <= 480 && width <= 896;
      setIsPhone(isPhonePortrait || isPhoneLandscape);
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return (
    <div className="transfer-key">
      {isPhone ? (
        <>
          <div className="key-item">
            <div className="color-cell" style={{ backgroundColor: '#f8d7da' }}></div>
            <div className="key-label">Unpaid</div>
          </div>
          <div className="key-item">
            <div className="color-cell" style={{ backgroundColor: '#d4edda' }}></div>
            <div className="key-label">Paid</div>
          </div>
                     <div className="key-item">
             <div className="color-cell" style={{ backgroundColor: '#d6eaf8' }}></div>
             <div className="key-label">Unallocated</div>
           </div>
           <div className="key-item">
             <div className="color-cell" style={{ backgroundColor: '#fdebd0' }}></div>
             <div className="key-label">Remaining</div>
           </div>
        </>
      ) : (
        <>
          <div className="key-item">
            <div className="color-cell" style={{ backgroundColor: '#fdebd0' }}></div>
            <div className="key-label">Remaining for Account</div>
          </div>
          <div className="key-item">
            <div className="color-cell" style={{ backgroundColor: '#d6eaf8' }}></div>
            <div className="key-label">Unallocated from Pay</div>
          </div>
        </>
      )}
    </div>
  );
};

export default TransferKey;
